import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=504aa3a4&scoped=true&"
import script from "./Merchant.vue?vue&type=script&lang=js&"
export * from "./Merchant.vue?vue&type=script&lang=js&"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=504aa3a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504aa3a4",
  null
  
)

export default component.exports